'use strict';

var gridPhotoCtrl = ['$state', '$uibModal', function ($state, $uibModal) {
    var _this = this;
    _this.viewPhotos = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'directives/gridPhotosDirective.html',
            controller: ['photos', function (photos) {
                var modal=this;
                this.photos = photos.value;
                this.isVideo = photos.type == "video"                
                var fetchAsBlob = url => fetch(url)
                    .then(response => response.blob());

                var convertBlobToBase64 = blob => new Promise((resolve, reject) => {
                    const reader = new FileReader;
                    reader.onerror = reject;
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.readAsDataURL(blob);
                });

                this.playVideo2 = function (uri, idx) {
                    fetchAsBlob(`${uri}?base64=1`)
                        .then(convertBlobToBase64)
                        .then((data) => {
                            var vid = document.getElementById(`mVideo${idx}`);
                            vid.src = data;
                            vid.load();
                            vid.play();
                        })

                }
                this.playVideo = function (uri, idx) {
                    var req = new XMLHttpRequest();
                    this.photos[idx].loaded=false;
                    req.open('GET', uri, true);
                    req.responseType = 'blob';
                    var vid = document.getElementById(`mVideo${idx}`);
                    req.onload = function () {                        
                        if (this.status === 200) {
                            var videoBlob = this.response;
                            var video = URL.createObjectURL(videoBlob);                             
                            vid.src = video;
                            modal.photos[idx].loaded=true;
                            //vid.play();
                            
                        }
                    }
                    req.onerror = function () {
                        // Error
                        modal.photos[idx].loaded=undefined;
                    }

                    req.send();

                }
            }],
            controllerAs: 'modal',
            size: 'md',
            resolve: {
                photos: function () {
                    return (_this.data.payload? _this.data.payload[_this.field] :{value: _this.data[_this.field], type:_this.type} ) ;
                }
            },
            windowClass: 'dialog',
            bindToController: true
        });

        modalInstance.result.then(function (selectedItem) {
            _this.selected = selectedItem;
        }, function () {

        });
    };



}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            data: '=',
            type: '='
        },
        controller: gridPhotoCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        template: '<a ng-click="ctrl.viewPhotos(); $event.stopPropagation()">Ver galeria</a>'
    };
};
